import { render } from "./NavigationPanel.vue?vue&type=template&id=4ed6f4ca&scoped=true"
import script from "./NavigationPanel.vue?vue&type=script&lang=js"
export * from "./NavigationPanel.vue?vue&type=script&lang=js"

import "./NavigationPanel.vue?vue&type=style&index=0&id=4ed6f4ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed6f4ca"]])

export default __exports__